import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("it_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  // kaunsa bahi-khaata — bina GST ya GST
  try {
    if (localStorage.getItem("it_book") === "gst") cfg.headers["X-Book"] = "gst"; else if (cfg && cfg.headers) { try { delete cfg.headers["X-Book"]; } catch (e) {} }
  } catch { /* ignore */ }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    // Galat bahi-khaata? Login 401 par doosri book me ek baar and try karo (stale it_book fix)
    const _cfg = err?.config || {};
    const _url = _cfg.url || "";
    const _isLogin = _url.endsWith("/auth/login") || _url.endsWith("/auth/pin-login") || _url.endsWith("/auth/pin-only-login");
    if (_isLogin && !_cfg.__bookRetry && err?.response?.status === 401) {
      let _cur = "main";
      try { _cur = localStorage.getItem("it_book") === "gst" ? "gst" : "main"; } catch (e) {}
      const _other = _cur === "gst" ? "main" : "gst";
      try { localStorage.setItem("it_book", _other); } catch (e) {}
      _cfg.__bookRetry = true;
      try { return await api(_cfg); }
      catch (e2) { try { localStorage.setItem("it_book", _cur); } catch (e) {} return Promise.reject(err); }
    }
    if (err?.response?.status === 401 && localStorage.getItem("it_token")) {
      // Token expired — clear and redirect
      localStorage.removeItem("it_token");
      try { localStorage.removeItem("it_admin_session"); } catch { /* ignore */ }
      if (window.location.pathname !== "/login") {
        // ?expired=1 -> login screen par saaf likha aayega kyun aaye ho
        window.location.href = "/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

/** Poori galti ka asli matlab — taaki pata chale kya karna hai.
 *  err = axios ka error object (pura), sirf detail nahi. */
export function explainError(err) {
  // 1) Server tak pahunch hi nahi — sabse aam wajah
  if (err && !err.response) {
    const code = err.code || "";
    if (code === "ECONNABORTED" || /timeout/i.test(err.message || "")) {
      return {
        msg: "Network is very slow — no response",
        hint: "Try another network or a mobile hotspot",
        network: true,
      };
    }
    return {
      msg: "Cannot reach the server",
      hint: "1) Is this device's date/time correct? (a wrong time can stop the site loading)  2) Is the internet working?  3) Try turning off your antivirus's web-shield",
      network: true,
    };
  }
  const st = err?.response?.status;
  const d = err?.response?.data?.detail;
  // 2) Server ne saaf jawab diya
  if (d != null) return { msg: formatApiErrorDetail(d), hint: "", network: false };
  // 3) Jawab to aaya par samajh nahi aaya (502/504 = server band ya busy)
  if (st === 502 || st === 503 || st === 504) {
    return { msg: "The server is not responding right now", hint: "Please try again in a minute or two", network: false };
  }
  if (st === 429) return { msg: "Too many attempts — please wait a while", hint: "", network: false };
  if (st >= 500) return { msg: `Server error (${st})`, hint: "This needs to be fixed on our side", network: false };
  return { msg: `Something went wrong (${st || "?"})`, hint: "Please try again", network: false };
}

/** Purani copy remove — service worker + cache saaf karke new app lao */
export async function hardReset() {
  try {
    if ("caches" in window) {
      const k = await caches.keys();
      await Promise.all(k.map((x) => caches.delete(x)));
    }
    if (navigator.serviceWorker) {
      const rs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(rs.map((r) => r.unregister()));
    }
  } catch { /* ignore */ }
  window.location.replace("/login?fresh=" + Date.now());
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtINR(n) {
  const v = Number(n || 0);
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(v);
}

export function fmtNumber(n, opts = {}) {
  const v = Number(n || 0);
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: opts.decimals ?? 0,
    minimumFractionDigits: opts.decimals ?? 0,
  }).format(v);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default api;


/** Samay ke hisaab se greeting — Good morning / afternoon / evening */
export function greetingNow(d) {
  const h = (d instanceof Date ? d : new Date()).getHours();
  if (h >= 5 && h < 12) return "Good morning";
  if (h >= 12 && h < 17) return "Good afternoon";
  return "Good evening";
}


/* ═══ THEME — light (default) / dark, yaad rehta hai ═══ */
export const THEME_KEY = "it_theme";
export function getTheme() {
  try { return localStorage.getItem(THEME_KEY) || "light"; } catch { return "light"; }
}
export function applyTheme(t) {
  const v = t === "dark" ? "dark" : "light";
  document.documentElement.setAttribute("data-theme", v);
  try { localStorage.setItem(THEME_KEY, v); } catch { /* ignore */ }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", v === "dark" ? "#030305" : "#eaeff5");
  return v;
}

/* ═══ Do alag bahi-khaate ═══
   "main" = bina GST (jo hamesha se chal raha hai)
   "gst"  = GST wala, bilkul alag database
   Ek ka data doosre me nahi aata. */
export function currentBook() {
  try { return localStorage.getItem("it_book") === "gst" ? "gst" : "main"; } catch { return "main"; }
}

export function setBook(b) {
  try { localStorage.setItem("it_book", b === "gst" ? "gst" : "main"); } catch { /* ignore */ }
}

export function isGstBook() {
  return currentBook() === "gst";
}

export const GST_RATE = 18;

/** ₹500 (GST milakar) -> { taxable, cgst, sgst } */
export function gstSplit(total, rate = GST_RATE) {
  const t = Math.round((Number(total) || 0) * 100) / 100;
  const r = Number(rate) || 0;
  if (!t || r <= 0) return { taxable: t, tax: 0, cgst: 0, sgst: 0, rate: r };
  const taxable = Math.round((t / (1 + r / 100)) * 100) / 100;
  const tax = Math.round((t - taxable) * 100) / 100;
  const half = Math.round((tax / 2) * 100) / 100;
  return { taxable, tax, cgst: half, sgst: Math.round((tax - half) * 100) / 100, rate: r };
}

/* ═══════════════════════════════════════════════════════════════════
   App ka "atakna" band karne ke do chhote intezaam
   1) Ek hi button par jaldi-jaldi do click = ek hi gina jaye
   2) Server se baat chal rahi ho to upar patli patti dikhe
   ═══════════════════════════════════════════════════════════════════ */
if (typeof window !== "undefined" && !window.__itUx) {
  window.__itUx = true;

  // 1) galti se do baar dab jaye to doosra chhod do
  document.addEventListener("click", (e) => {
    const b = e.target?.closest?.("button, [role='button']");
    if (!b || b.disabled) return;
    const now = Date.now();
    if (b.__itLast && now - b.__itLast < 450) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    b.__itLast = now;
  }, true);

  // 2) patli patti — kuch ho raha hai ye dikhta rahe
  let live = 0;
  const bar = document.createElement("div");
  bar.id = "it-busy-bar";
  const mount = () => { if (document.body && !bar.parentNode) document.body.appendChild(bar); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mount);
  else mount();

  const show = () => { mount(); bar.classList.add("on"); bar.style.width = "35%"; };
  const bump = () => { bar.style.width = "70%"; };
  const done = () => {
    bar.style.width = "100%";
    setTimeout(() => { bar.classList.remove("on"); bar.style.width = "0"; }, 220);
  };

  api.interceptors.request.use((cfg) => {
    live += 1;
    if (live === 1) show(); else bump();
    return cfg;
  });
  const settle = () => { live = Math.max(0, live - 1); if (live === 0) done(); };
  api.interceptors.response.use(
    (r) => { settle(); return r; },
    (e) => { settle(); return Promise.reject(e); },
  );
}

/* ═══════════════════════════════════════════════════════════════════
   Token apne aap taaza — beech kaam me logout na ho.
   Har 30 minute me, and jab bhi tab wapas saamne aaye.
   ═══════════════════════════════════════════════════════════════════ */
if (typeof window !== "undefined" && !window.__itRefresh) {
  window.__itRefresh = true;
  let last = 0;
  const refresh = async () => {
    if (!localStorage.getItem("it_token")) return;
    if (Date.now() - last < 5 * 60 * 1000) return;   // 5 min me ek se zyada nahi
    last = Date.now();
    try {
      const { data } = await api.post("/auth/refresh");
      if (data?.token) localStorage.setItem("it_token", data.token);
    } catch { /* fail ho to chhodo — 401 wala handler sambhal lega */ }
  };
  setInterval(refresh, 30 * 60 * 1000);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") refresh();
  });
  setTimeout(refresh, 4000);
}
